module.exports = __webpack_public_path__ + "static/media/squarelist.fc8de932.png";